import React from 'react';
import projectContent from '../data/research-content'
import Slider from '../components/Slider';

const ResearchPage = ({ match  }) => {
    const name = match.params.name;
    const article = projectContent.find(article => article.name === name);
    if (!article) return <h1>Content will be added soon</h1>

    return (
        <>
        <h3 className="articleTitle">{article.title}</h3>
        <Slider photos={article.images}/>
        {article.content.map((paragraph, key) => (
            <p className="paragraphContent" key={key}>{paragraph}</p>
        ))}
        </>
    );
}

export default ResearchPage;